export default __webpack_public_path__ + "static/media/september-min.81908f5a.jpg";